import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCircleCheck, faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { MenuBarComponent } from '../../core/components/menu-bar/menu-bar.component';
import { FooterComponent } from '../../core/components/footer/footer.component';
import { AuthService } from '../../core/services/auth.service';

type ActivationState = 'loading' | 'success' | 'failed';

/**
 * Account-activation landing page (port of the old site's activate_account.php).
 * The cloud's registration email links here with a `?code=...`; we relay the
 * code to our backend, which calls the cloud to activate the account, then show
 * a success/failure message.
 */
@Component({
    selector: 'app-activate-account',
    imports: [CommonModule, RouterLink, FontAwesomeModule, MenuBarComponent, FooterComponent],
    templateUrl: './activate-account.component.html',
    styleUrl: './activate-account.component.scss',
})
export class ActivateAccountComponent implements OnInit {
    state: ActivationState = 'loading';

    readonly faCircleCheck = faCircleCheck;
    readonly faCircleXmark = faCircleXmark;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authService: AuthService,
    ) { }

    ngOnInit(): void {
        const code = this.route.snapshot.queryParamMap.get('code');
        if (!code) {
            // No code -> nothing to activate (legacy redirected to /my-account/).
            this.router.navigate(['/']);
            return;
        }
        this.authService.activateAccount(code).subscribe({
            next: (res) => { this.state = res?.success ? 'success' : 'failed'; },
            error: () => { this.state = 'failed'; },
        });
    }
}
